import { CampaignTypeFilter } from '@dev/ee-api/ee-api-models';
import { Pagination, Paper } from '@dev/ee-components';
import { isEmpty, omit } from 'lodash-es';
import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { GetCampaigns, getCampaignsStore } from '@/store/campaigns/actions';
import useMobile from '@/services/hooks/useMobile';

const PaginationWrapper = styled(Paper)`
    display: flex;
    justify-content: center;
    padding-top: 24px;
    padding-bottom: 24px;
`;

const CustomPagination: FC = (): JSX.Element => {
    const campaigns = useSelector(getCampaignsStore);
    const dispatch = useDispatch();
    const isMobile = useMobile();

    const screenCampaignType = [CampaignTypeFilter.Draft];

    const changePage = (page: number, perPage: number): void => {
        const offset = page * perPage - perPage;
        const rest = omit(campaigns.pagination, ['activePage', 'perPage']);

        dispatch(GetCampaigns({ ...rest, type: screenCampaignType, limit: perPage, offset }));
    };

    return isEmpty(campaigns?.collection) && !campaigns?.loading ? null : isMobile ? (
        <PaginationWrapper>
            <Pagination
                dataLength={campaigns?.statusCount?.total}
                perPage={campaigns?.pagination?.perPage}
                activePage={campaigns.pagination.activePage}
                handlePaginationChange={changePage}
                siblingCount={1}
                boundaryCount={1}
                disableBorderTop
            />
        </PaginationWrapper>
    ) : (
        <Pagination
            dataLength={campaigns?.statusCount?.total}
            perPage={campaigns?.pagination?.perPage}
            activePage={campaigns.pagination.activePage}
            handlePaginationChange={changePage}
        />
    );
};

export default CustomPagination;
